import { RootState } from "../../../../../redux/store";

export const vehiclesLoading = (state: RootState) => state.vehicles.itemsLoading;
export const vehiclesActionLoading = (state: RootState) => state.vehicles.actionsLoading;
export const dropDownLoading = (state: RootState) => state.vehicles.dropDownLoading;

export const vehicles = (state: RootState) => state.vehicles.items;
export const vehiclesCount = (state: RootState) => state.vehicles.itemsCount;
export const vehicleForEdit = (state: RootState) => state.vehicles.itemForEdit;
export const getItemsSelect = (state: RootState) => state.vehicles.dropDownItems;

export const error = (state: RootState) => state.vehicles.error;
export const errorAction = (state: RootState) => state.vehicles.errorAction;
export const dropDownError = (state: RootState) => state.vehicles.dropDownError;

export const validationErrors = (state: RootState) => state.vehicles.validationErrors;

export const filters = (state: RootState) => state.vehicles.filters;
